export var NodeEvent = /* @__PURE__ */ ((NodeEvent2) => {
  NodeEvent2["CREATED"] = "node_created";
  NodeEvent2["DELETED"] = "node_deleted";
  NodeEvent2["NAME_UPDATED"] = "node_name_update";
  NodeEvent2["OVERRIDE_CLONABLE_STATE_UPDATE"] = "node_override_clonable_state_update";
  NodeEvent2["NAMED_OUTPUTS_UPDATED"] = "node_named_outputs_updated";
  NodeEvent2["NAMED_INPUTS_UPDATED"] = "node_named_inputs_updated";
  NodeEvent2["INPUTS_UPDATED"] = "node_inputs_updated";
  NodeEvent2["PARAMS_UPDATED"] = "node_params_updated";
  NodeEvent2["UI_DATA_POSITION_UPDATED"] = "node_ui_data_position_updated";
  NodeEvent2["UI_DATA_COMMENT_UPDATED"] = "node_ui_data_comment_updated";
  NodeEvent2["ERROR_UPDATED"] = "node_error_updated";
  NodeEvent2["FLAG_BYPASS_UPDATED"] = "bypass_flag_updated";
  NodeEvent2["FLAG_DISPLAY_UPDATED"] = "display_flag_updated";
  NodeEvent2["FLAG_OPTIMIZE_UPDATED"] = "optimize_flag_updated";
  NodeEvent2["SELECTION_UPDATED"] = "selection_updated";
  return NodeEvent2;
})(NodeEvent || {});
